import { useQuery } from 'react-query';

import { useRequest, queryClient, type QueryFunction } from '@frontend/api';

import type { AgentConversationListData, AgentType } from './types';

type ListConversationsQueryParams = {
  quoteId?: number;
  agentType: AgentType;
};

export const getUseListConversationsKey = (
  params: ListConversationsQueryParams,
) => ['agents', 'list', params.agentType, String(params.quoteId ?? '')];

export const useListConversations: QueryFunction<
  AgentConversationListData[],
  [ListConversationsQueryParams],
  ReturnType<typeof getUseListConversationsKey>
> = (params, { queryOptions, requestOptions } = {}) => {
  const request = useRequest(requestOptions);

  return useQuery({
    ...queryOptions,
    queryKey: getUseListConversationsKey(params),
    queryFn: ({ signal }) => {
      return request<AgentConversationListData[]>(`/agents/conversations`, {
        query: {
          agentType: params.agentType,
          ...(params.quoteId ? { quoteId: params.quoteId } : {}),
        },
        init: {
          signal,
        },
      });
    },
  });
};

export const invalidateListConversationsQuery = (
  params: ListConversationsQueryParams,
) => {
  queryClient.invalidateQueries(getUseListConversationsKey(params));
};
